import { z } from 'zod';
import { calendarDateSchema, instantSchema, uuidSchema } from '../schema/rows.js';
const asapInput = z.object({
    workspace_id: uuidSchema,
    /** Start of the current period (ISO instant): completed tasks since then stay visible. */
    period_start: instantSchema,
    /** Today as `YYYY-MM-DD` (client clock). */
    today: calendarDateSchema,
    /** The signed-in user (`$me`). */
    user_id: uuidSchema,
    /** Area lens: only blocks whose effective tag of the taxonomy is this tag. */
    lens: z.object({ taxonomy_id: uuidSchema, tag_id: uuidSchema }).nullable().default(null),
    stage_key: z.string().min(1).default('asap'),
});
export const ASAP_COLUMNS = 'b.id, b.title, b.kind, b.status, b.due_on, b.sort_key, b.completed_at, b.parent_id';
/** SQL and parameters of the ASAP view over the local database. */
export function compileAsapQuery(input) {
    const p = asapInput.parse(input);
    const lensJoin = p.lens
        ? '\nJOIN effective_tags et ON et.block_id = b.id AND et.taxonomy_id = ? AND et.tag_id = ?'
        : '';
    const lensParams = p.lens ? [p.lens.taxonomy_id, p.lens.tag_id] : [];
    return {
        sql: `SELECT ${ASAP_COLUMNS}
FROM blocks b
JOIN stages s ON s.id = b.stage_id AND s.key = ?${lensJoin}
WHERE b.workspace_id = ?
  AND b.deleted_at IS NULL AND b.archived_at IS NULL
  AND (b.status = 'open' OR (b.status = 'done' AND b.completed_at >= ?))
  AND (b.start_on IS NULL OR b.start_on <= ?)
  AND (b.assignee_id IS NULL OR b.assignee_id = ?)
ORDER BY (b.due_on IS NULL) ASC, b.due_on ASC, b.sort_key ASC`,
        params: [p.stage_key, ...lensParams, p.workspace_id, p.period_start, p.today, p.user_id],
    };
}
/** Context tags of the listed blocks (for `group_by: tag:context`), one row per block/tag. */
export function compileContextTagsQuery(taxonomyId, blockIds) {
    if (blockIds.length === 0)
        return { sql: 'SELECT NULL AS block_id, NULL AS tag_id WHERE 0', params: [] };
    return {
        sql: `SELECT bt.block_id, bt.tag_id FROM block_tags bt
WHERE bt.taxonomy_id = ? AND bt.block_id IN (${blockIds.map(() => '?').join(', ')})`,
        params: [taxonomyId, ...blockIds],
    };
}
/** Groups rows by tag id (blocks without a tag go under `null`), preserving row order. */
export function groupBy(rows, tagsOf) {
    const byBlock = new Map();
    for (const t of tagsOf)
        (byBlock.get(t.block_id) ?? byBlock.set(t.block_id, []).get(t.block_id)).push(t.tag_id);
    const groups = new Map();
    for (const row of rows) {
        const tags = byBlock.get(row.id) ?? [null];
        for (const tag of tags)
            (groups.get(tag) ?? groups.set(tag, []).get(tag)).push(row);
    }
    return groups;
}
//# sourceMappingURL=asap.js.map